module.exports = __webpack_public_path__ + "static/media/promo-fragaria.b62a5061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-fragaria.jpg
// module id = 311
// module chunks = 0